"use client";

import { useEffect, useState } from "react";
import type { CarouselApi } from "../components/Carousel/types";

export function useHasMultipleSlides(api: CarouselApi | undefined | null) {
  const [hasMultipleSlides, setHasMultipleSlides] = useState(false);

  useEffect(() => {
    if (api) {
      const slideCount = api.slideNodes().length;
      setHasMultipleSlides(slideCount > 1);
    }
  }, [api]);

  return hasMultipleSlides;
}
